/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Data Imports */

import AppConfig from "../../../../AppConfig";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  areaUnitRow: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "space-between",
    },
  },
  areaUnitBlock: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "2rem",
    [theme.breakpoints.down("xs")]: {
      marginRight: "0rem",
    },
  },
  areaUnitIconLabels: {
    display: "flex",
    flexDirection: "column",
    alignItems: "space-between",
    justifyContent: "flex-start",
    marginLeft: "0.5rem",
  },
}));

const PICAreaUnit = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.areaUnitRow}>
        <div className={classes.areaUnitBlock}>
          <img
            alt={AppConfig.imageAltText}
            loading="lazy"
            referrerPolicy="no-referrer"
            height={32}
            width={32}
            src="/images/icons/config/area.svg"
          />
          <div className={classes.areaUnitIconLabels}>
            <span
              style={{
                fontSize: "0.75rem",
                fontWeight: 300,
                color: "#202020",
              }}
            >
              Area
            </span>
            <span
              style={{ fontSize: "1rem", fontWeight: 400, color: "#202020" }}
            >
              {props.area ? props.area : "Area"}
            </span>
          </div>
        </div>
        <div className={classes.areaUnitBlock}>
          <img
            alt={AppConfig.imageAltText}
            loading="lazy"
            referrerPolicy="no-referrer"
            height={32}
            width={32}
            src={
              props.unitIcon
                ? props.unitIcon
                : "/images/icons/property/building.svg"
            }
          />
          <div className={classes.areaUnitIconLabels}>
            <span
              style={{
                fontSize: "0.75rem",
                fontWeight: 300,
                color: "#202020",
              }}
            >
              Unit
            </span>
            <span
              style={{ fontSize: "1rem", fontWeight: 400, color: "#202020" }}
            >
              {props.config ? props.config : "Config"}
            </span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PICAreaUnit;
